var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconcontactsphonemobile = function SvgIconcontactsphonemobile(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/contacts/icon.contacts.phone.mobile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/contacts/icon.contacts.phone.mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#09BE86",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 11,
    height: 21,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 22,
    x2: 8.5,
    y2: 22,
    id: "Line-10",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 1,
    x2: 9,
    y2: 1,
    id: "Line-11",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconcontactsphonemobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.contacts.phone.mobile.a5c114c65dac0dac6d06278ae5f0351f.svg";